export default function MySQL_MAKEDATE() {
  return (
    <div>
      <h2>MySQL_MAKEDATE</h2>    </div>
  );
}